// extracted by mini-css-extract-plugin
export default {"dot":"index_dot_SJDwe","current":"index_current_48GlB index_dot_SJDwe"};